export class WalletTransaction {
    constructor(
        readonly id: string,
        readonly date: Date,
        readonly amount: number,
        readonly remainingBalance: number,
        readonly type: WalletTransactionType,
        readonly description: string,
        readonly category: string,
    ) {}
}

export enum WalletTransactionType {
    RECHARGE,
    SPENDING,
}